import { Component } from '@angular/core';

@Component({
  selector: 'app-cards11-examples-71',
  templateUrl: './cards11-examples-71.component.html'
})
export class Cards11Examples71Component {}
